<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between px-4">
      <div class="col-lg-6 mt-2 mt-lg-0">
        <ul
          class="nav nav-footer justify-content-center justify-content-lg-start"
          v-show="showSocial"
        >
          <li class="nav-item">
            <a
              href="https://www.facebook.com/AceleradoraStars/"
              class="nav-link"
              target="_blank"
              ><i class="fab fa-facebook text-lg"></i
            ></a>
          </li>
          <li class="nav-item">
            <a
              href="https://www.instagram.com/starsaceleradora/?hl=pt-br"
              class="nav-link"
              target="_blank"
              ><i class="fab fa-instagram text-lg"></i
            ></a>
          </li>
          <li class="nav-item">
            <a
              href="https://www.linkedin.com/company/starsaceleradora?originalSubdomain=br"
              class="nav-link"
              target="_blank"
              ><i class="fab fa-linkedin text-lg"></i
            ></a>
          </li>
        </ul>
      </div>
      <div class="col-lg-6 mt-0">
        <div class="copyright text-center text-lg-right text-muted">
          © {{ year }}
          Powered by
          <a
            href="https://starsaceleradora.com.br/"
            class="font-weight-bold text-orange"
            target="_blank"
            >Stars Aceleradora</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    showSocial: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style scoped>
.footer .nav-link {
  padding: 0 0.75rem;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50px;
  padding: 0;
  line-height: 50px;
  background-color: transparent;
}
</style>
<style>
html {
  position: relative;
  min-height: 100%;
}
.main-content {
  margin-bottom: 5rem;
}
</style>
